import { IApplicationState } from '../../types/redux';

export const selectStatus = (state: IApplicationState) => {
  return state.buildersProjects.status;
};
